import { FormControl, FormItem } from "../ui/form";
import {
	Controller,
	type FieldValues,
	type Path,
	type UseFormReturn,
} from "react-hook-form";
import { Switch } from "../ui/switch";

type FormTextAreaProps<T extends FieldValues> = {
	form: UseFormReturn<T>;
	name: Path<T>;
	onClick?: () => void;
};

export const FormSwitch = <T extends FieldValues>({
	form,
	name,
	onClick,
}: FormTextAreaProps<T>) => {
	return (
		<Controller
			control={form.control}
			name={name}
			render={({ field }) => {
				return (
					<FormItem onClick={onClick} className="w-fit">
						<FormControl>
							<Switch
								id="is-active"
								checked={field.value}
								className={field.value ? "bg-primarybuttonbg" : ""}
								onCheckedChange={field.onChange}
							/>
						</FormControl>
					</FormItem>
				);
			}}
		/>
	);
};
